import React from 'react';

import {Col} from 'antd';
import AppRowSimpleContainer from '@crema/core/AppRowContainer/AppRowSimpleContainer';
import {BodyHeight} from './BodyHeight';
import {BodyWeight} from './BodyWeight';
import {BodyTemp} from './BodyTemp';
import {BloodPressure} from './BloodPressure';
import {HeartRate} from './HeartRate';
import {RespRate} from './RespRate';
import {OxygenSat} from './OxygenSat';

export const Vitals = (props) => {
  return (
    <>
      <AppRowSimpleContainer>
        <Col span={8}>
          <BodyHeight {...props} />
        </Col>
        <Col span={8}>
          <BodyWeight {...props} />
        </Col>
        <Col span={8}>
          <BodyTemp {...props} />
        </Col>
      </AppRowSimpleContainer>
      <AppRowSimpleContainer>
        <Col span={6}>
          <BloodPressure {...props} />
        </Col>
        <Col span={6}>
          <HeartRate {...props} />
        </Col>
        <Col span={6}>
          <RespRate {...props} />
        </Col>
        <Col span={6}>
          <OxygenSat {...props} />
        </Col>
      </AppRowSimpleContainer>
    </>
  );
};
